var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-w-full tw-flex tw-fixed tw-z-10 tw-bg-footy-light-grey tw-overflow-x-auto tw-md:tw-overflow-x-hidden navigation-tabs"
    },
    [
      _c(
        "div",
        {
          staticClass: "tw-cursor-pointer white-bottom-border tab",
          class: _vm.tab === 1 ? "active-tab" : "",
          on: {
            click: function($event) {
              return _vm.changeTab(1)
            }
          }
        },
        [
          _c("span", { staticClass: "tw-font-semibold" }, [
            _vm._v(" Competition ")
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "tw-cursor-pointer white-bottom-border tab",
          class: _vm.tab === 2 ? "active-tab" : "",
          on: {
            click: function($event) {
              return _vm.changeTab(2)
            }
          }
        },
        [
          _c("span", { staticClass: "tw-font-semibold" }, [
            _vm._v(" Settings ")
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }